/*global jQuery, enquire, document, window, history, whatInput, Cookies */
jQuery(function () {
	"use strict";
	var
		$ = jQuery.noConflict(),
		html_tag = $(document.documentElement),
		body_tag = $(document.getElementsByTagName('body')),

		bottom_id = $(document.getElementById('bottom')),
		cart_id = $(document.getElementById('cart')),
		footer_id = $(document.getElementById('footer')),
		login_id = $(document.getElementById('login')),
		nav_id = $(document.querySelectorAll('[id^="nav"]')),
		root_id = $(document.getElementById('root')),
		skip_id = $(document.getElementById('skip')),
		top_bar = $(document.getElementById('top-bar')),
		top_id = $(document.getElementById('top')),
		top_sh = $(document.getElementById('top-sh')),
		product_select_id = $(document.getElementById('productSelect')),

		a_tag = $(document.getElementsByTagName('a')),
		a_tag_external = $(document.querySelectorAll('a[rel*="external"]')),
		a_tag_anchor = $('a[href^="#"]:not([data-popup], [href="#nav"], [href="#mobile"], [href="#"])'),
		bubble_class = $(document.getElementsByClassName('bubble')),
		form_lightspeed = $(document.querySelectorAll('#filter_form, #formFilter, #formSortModeLimit1, #formSortModeLimit2')),
		form_product = $(document.getElementsByClassName('form-product')),
		form_sort = $(document.getElementsByClassName('form-sort')),
		form_login = $(document.getElementsByClassName('form-login')),
		form_address_country_option = $(document.getElementsByClassName('address-country-option')),
		list_collection = $(document.getElementsByClassName('list-collection')),
		list_view = $(document.getElementsByClassName('list-view')),
		list_select = $(document.getElementsByClassName('list-select')),
		mobile_tab = $(document.getElementsByClassName('mobile-tab')),
		module_featured = $(document.getElementsByClassName('module-featured')),
		module_quickshop = $(document.getElementsByClassName('module-quickshop')),
		module_product = $(document.getElementsByClassName('module-product')),
		module_product_sticky = $(document.getElementsByClassName('module-product-sticky')),
		module_sections = $(document.getElementsByClassName('module-sections')),
		toggle_quickshop = $(document.getElementsByClassName('quickshop')),
		toggle_filters = $(document.getElementsByClassName('toggle-filters')),
		advanced_filters = $(document.getElementsByClassName('advanced-filter')),
		blog_tags = $(document.getElementsByClassName('blog-tags')),
		quantity_select = $(document.getElementsByClassName('qty_update')),
		variant_select_snippet = $(document.getElementsByClassName('variant-select-snippet')),

		form_children = $(document.querySelectorAll('form > *')).add(list_collection.children('li')).add(list_select.children('li')).add($(document.getElementsByClassName('fieldset')).children()),
		loadRes = function (u, c, i) {
			if (html_tag.is('.' + i)) {
				c();
				return true;
			}
			var s = document.createElement('script');
			s.src = u;
			s.async = true;
			s.onload = c;
			document.body.appendChild(s);
			html_tag.not('.' + i).addClass(i);
			return true;
		},
		Default = {
			async: {
				links: function () {
					if (a_tag_external.length) {
						a_tag_external.on('click', function (e) {
							e.preventDefault();
							window.open($(this).attr('href'));
						}).attr('rel', 'external noopener');
					}
					if (skip_id.length) {
						skip_id.find('a').attr('aria-hidden', true).on('focus', function () {
							$(this).attr('aria-hidden', false);
						}).on('blur', function () {
							$(this).attr('aria-hidden', true);
						});
					}
					if (bubble_class.length) {
						bubble_class.closest('a').on('click', function () {
							$(this).toggleClass('toggle').parents('p').toggleClass('high-index');
							return false;
						});
					}
				},
				forms: function () {
					if (form_children.length) {
						form_children.each(function (k, v) {
							$(v).css('z-index', (form_children.length - k));
						});
					}
					if (form_sort.find('.link').length) {
						form_sort.find('.link').children('a').on('click', function () {
							$(this).find('span').toggleClass('hidden').closest('.link').toggleClass('toggle');
							return false;
						});
					}
					html_tag.on('click', function () {
						footer_id.find('.lang.toggle').add(bubble_class.closest('a')).removeClass('toggle');
						$('.high-index').removeClass('high-index');
						html_tag.removeClass('search-active');
					});
					top_id.add(top_sh).children('form').on('click', function (e) {
						e.stopPropagation();
					});
					if (form_login.length) {
						form_login.find('.hidden').addClass('is-hidden').next('p').find('a').on('click', function () {
							$(this).closest('p').toggleClass('hidden').prev('.is-hidden').toggleClass('hidden');
							return false;
						});
					}
					if (form_address_country_option.length) {
						form_address_country_option.each( function () {
							var defaultCountry = $(this).data('default');
							$(this).find('option[value="'+defaultCountry+'"]').attr('selected','selected');
						})
					}
				},
				nav: function () {
					if (top_id.filter(':not(.v2)').is(':has(.bar)')) {
						// html_tag.removeClass('no-usp');
						$('.bar').show();
						if (module_featured.length) {
							module_featured.children('.inner').trigger('refresh.owl.carousel');
						}
					}
					if (top_id.filter('.v2').is(':not(:has(.bar))')) {
						html_tag.addClass('no-usp2');
						if (module_featured.length) {
							module_featured.children('.inner').trigger('refresh.owl.carousel');
						}
					}
					body_tag.on('announcement-bar', function (event) {
						top_id = $(document.getElementById('top'));
						if (Cookies.get('has-bar') === 'no') {
							// top_id.add(top_bar).children('p:not(#logo)').remove();
							// html_tag.removeClass('has-bar').addClass('closed-bar');
							// if (module_featured.length) {
							// 	module_featured.children('.inner').trigger('refresh.owl.carousel');
							// }
							// if (html_tag.is('.no-usp')) {
							// 	top_id.trigger('detach.ScrollToFixed').scrollToFixed();
							// } else {
							// 	top_id.trigger('detach.ScrollToFixed').scrollToFixed({
							// 		marginTop: -47
							// 	});
							// }
						// } else {
							// if (top_id.children('p:not(#logo)').length) {
							// 	html_tag.delay(500).queue(function () {
							// 		$(this).addClass('has-bar').dequeue();
							// 		if (module_featured.length) {
							// 			module_featured.children('.inner').trigger('refresh.owl.carousel');
							// 		}
							// 	});
							// }
							// if (html_tag.is('.no-usp')) {
							// 	top_id.trigger('detach.ScrollToFixed').scrollToFixed();
							// } else {
							// 	top_id.trigger('detach.ScrollToFixed').scrollToFixed({
							// 		marginTop: -47
							// 	});
							// }
						}
							// if (!top_id.hasClass('no-sticky-header')) {
							// 	if (html_tag.is('.no-usp')) {
							// 		top_id.trigger('detach.ScrollToFixed').scrollToFixed();
							// 	} else {
							// 		top_id.trigger('detach.ScrollToFixed').scrollToFixed({
							// 			marginTop: -47
							// 		});
							// 	}
							// }
						// }
					});
					body_tag.trigger('announcement-bar');
					cart_id.each(function () {
						$(this).append('<a class="close" href="./"></a>').wrapInner('<div class="inner"></div>').find('.submit').appendTo($(this));
					});
					login_id.add(top_id.children('form')).add(top_sh.children('form')).add(top_id.children('p:not(#logo, .visible)')).add(top_bar).each(function () {
						$(this).append('<a class="close" href="./"></a>');
					});
					top_id.children('p:not(#logo)').add(top_bar).find('a.close').on('click', function () {
						Cookies.set('has-bar', 'no');
						html_tag.removeClass('has-bar').addClass('closed-bar');
						if (module_featured.length) {
							module_featured.children('.inner').trigger('refresh.owl.carousel');
						}
						if (html_tag.is('.no-usp')) {
							top_id.trigger('detach.ScrollToFixed').scrollToFixed();
						} else {
							top_id.trigger('detach.ScrollToFixed').scrollToFixed({
								marginTop: -47
							});
						}
						return false;
					});
					top_id.add(top_sh).children('form').append('<a href="./" class="remove" tabindex="-1">Clear</a>').each(function () {
						$(this).children('a.remove').on('click', function () {
							$(this).attr('tabindex', -1).parents('form').removeClass('full').find('input').val('');
							// if ($(window).width() <= 1000){
								html_tag.removeClass('search-active');
							// }
							return false;

						});
						$(this).find('input').on('keyup', function () {
							if ($(this).val().length > 0) {
								$(this).parents('form').addClass('full').find('a.remove').removeAttr('tabindex');
							} else {
								$(this).parents('form').removeClass('full').find('a.remove').attr('tabindex', -1);
							}
						}).each(function () {
							if (!Shopify.designMode) {
								if ($(this).val().length > 0) {
									$(this).parents('form').addClass('full').find('a.remove').removeAttr('tabindex');
								}
							}
						});
					});
					nav_id.each(function () {
						$(this).find('li > ul, li > div').attr({
							'aria-hidden': true,
							'focusable': false
						}).parent().on('mouseenter', function () {
							html_tag.removeClass('search-active');
						}).addClass('sub').children('a').attr('aria-expanded', false).each(function () {
							$(this).clone().addClass('toggle').attr('role', 'button').text('Toggle ' + $(this).text()).insertAfter($(this));
						}).siblings('a.toggle').add($(this).find('.lang > a')).add(bottom_id.find('li > ul').siblings('a')).on('click', function () {
							if ($(this).parent().is('.toggle')) {
								$(this).parent().removeClass('toggle').children('a:not(.toggle)').attr('aria-expanded', false).parent().children('ul').attr({
									'aria-hidden': true,
									'focusable': false
								});
							} else {
								$(this).closest('ul').find('li.toggle').removeClass('toggle').children('a:not(.toggle)').attr('aria-expanded', false).parent().children('ul').attr({
									'aria-hidden': true,
									'focusable': false
								});
								$(this).parent().addClass('toggle').children('a:not(.toggle)').attr('aria-expanded', true).parent().children('ul').attr({
									'aria-hidden': false,
									'focusable': true
								});
							}
							return false;
						});
						$(this).find('li > ul').parent().addClass('has-ul');
						$(this).find('li > div').parent().addClass('has-div').closest('ul').append('<span class="shadow"></span>');
						$(this).find('i[class*="menu"]').addClass('done').append('<span></span>');
					});

					top_id.add(top_sh).append('<a href="#mobile" class="menu" role="button" aria-controls="mobile" aria-expanded="false" data-target="#mobile"><div class="menu-icon"></div></a>').after('<nav id="mobile" aria-expanded="false" focusable="false" aria-hidden="true"></nav><a href="#mobile" id="shadow" role="button" tabindex="-1">Close</a>');
					var mobile_id = $(document.getElementById('mobile')),
						shadow_id = $(document.getElementById('shadow'));
					nav_id.children().clone().appendTo(mobile_id);
					mobile_id.each(function () {
						$(this).find('li > div > ul').unwrap();
						$(this).find('li.sub:not(.lang), .double').removeAttr('class');
						$(this).find(':header + ul').prev().each(function () {
							if ($(this).is(':has(a)')) {
								$(this).html('<li><a href="' + $(this).find('a').attr('href') + '">' + $(this).text() + '</a></li>').next('ul').appendTo($(this).children('li'));
							} else {
								$(this).html('<li><a href="./">' + $(this).text() + '</a></li>').next('ul').appendTo($(this).children('li'));
							}
							$(this).children('li').unwrap();
						});
						$(this).find('.list-gallery').attr('class', 'gallery');
						$(this).find('div > div > li, div > .gallery').unwrap();
						$(this).find('div > li').parent().each(function () {
							$(this).replaceWith('<ul>' + $(this).html() + '</ul>');
						});
						$(this).find('li > div').each(function () {
							$(this).replaceWith('<ul>' + $(this).html() + '</ul>');
						});
						$(this).find('li.search, .def-menu-icon, li.cart, a.toggle, .shadow').remove();
						$(this).find('li.lang').each(function () {
							$(this).appendTo($(this).parent());
						});
						$(this).find('ul > ul.gallery').each(function () {
							$(this).insertAfter($(this).parent());
						});


						$(this).find('a').attr('tabindex', -1).removeAttr('accesskey');
						$(this).prepend('<span class="title">' + nav_id.attr('aria-label') + ' <a href="#mobile" class="close"></a></span>');
						$(this).find('li > ul').after('<a href="./" class="toggle"></a>').next('a.toggle').on('click', function () {
							if ($(this).parent().is('.toggle')) {
								$(this).parent().removeClass('toggle').parents('ul:first').removeClass('ul-toggle');
								$(this).attr('aria-expanded', false).parent().removeClass('toggle').children('ul').attr({
									'aria-hidden': true,
									'focusable': false
								});
							} else {
								$(this).parents('ul:first').children('li.toggle').removeClass('toggle').parents('ul:first').removeClass('ul-toggle');
								$(this).parent().addClass('toggle').parents('ul:first').addClass('ul-toggle');
								$(this).attr('aria-expanded', true).parent().addClass('toggle').children('ul').attr({
									'aria-hidden': false,
									'focusable': true
								});
								$(this).parents('#mobile').addClass('active');
							}
							return false;
						}).parent('li').addClass('sub');
						$(this).find('.sub > a:not(.toggle)').each(function () {
							$(this).parent().children('ul').prepend('<li class="header"><a href="#mobile" class="close"></a> <a href="./" class="back">Back to categories</a> <span>' + $(this).text() + '</span></li>');
						});
						$(this).find('.header').children('a.back').on('click', function () {
							$(this).parents('#mobile').removeClass('active').each(function () {
								$(this).find('.ul-toggle, li.toggle').removeClass('ul-toggle toggle');
							});
							return false;
						});
						body_tag.trigger('lazyload-again', [$(this)]);
					});
					top_id.children('.menu').add('a[href="#mobile"]').add(shadow_id).attr('href', '#mobile').on('click', function () {
					if (html_tag.is('.menu-active')) {
							html_tag.removeClass('menu-active');
							mobile_id.attr({
								'aria-hidden': true,
								'focusable': false
							}).find('a').attr('tabindex', -1);
							top_id.children('.menu').attr('aria-expanded', false);
							shadow_id.attr('tabindex', -1);
							history.replaceState(null, null, ' ');
							return false;
						} else if (html_tag.is('.cart-active')) {
							html_tag.removeClass('cart-active');
						} else if (html_tag.is('.filter-active')) {
							html_tag.removeClass('filter-active');
						} else {
							html_tag.addClass('menu-active');
							mobile_id.attr({
								'aria-hidden': false,
								'focusable': true
							}).find('a').removeAttr('tabindex');
							top_id.children('.menu').attr('aria-expanded', true);
							shadow_id.removeAttr('tabindex');
							document.location.hash = $(this).attr('href').split('#')[1];
						}
					});
					nav_id.each(function () {
						$(this).find('.search > a').add(top_id.children('form').find('a.close')).add(top_sh.children('form').find('a.close')).on('click', function () {
							if (html_tag.is('.search-active')) {
								html_tag.removeClass('search-active');
							} else {
								nav_id.find('li.toggle').removeClass('toggle');
								html_tag.addClass('search-active').removeClass('login-active cart-active full-active');
								top_id.add(top_sh).children('form').find('input').focus();
							}
							return false;
						});
						$(this).find('.menu > a').on('click', function () {
							if (html_tag.is('.full-active')) {
								html_tag.removeClass('full-active');
							} else {
								nav_id.find('li.toggle').removeClass('toggle');
								html_tag.addClass('full-active').removeClass('login-active cart-active search-active');
							}
							return false;
						});
						$(this).add(bottom_id).add(mobile_id).find('.cart > a').add(cart_id.find('a.close')).on('click', function () {
							html_tag.toggleClass('cart-active').removeClass('login-active');
							return false;
						});
						$(this).add(bottom_id).add(mobile_id).find('.login > a').add(mobile_id.find('.login > a')).add(bottom_id.find('a:has(.icon-user-circle)')).add(login_id.find('a.close')).on('click', function () {
							// html_tag.toggleClass('login-active').removeClass('menu-active cart-active full-active');
							html_tag.removeClass('menu-active cart-active full-active');
							// return false;
						});
						if ($(this).is('.fixed')) {
							$(this).scrollToFixed({
								marginTop: -1
							});
						}
						if ($(this).is('.sticky')) {
							$(this).scrollToFixed({
								marginTop: -58
							});
						}
					});
					if (top_sh.length) {
						top_sh.filter(':not(.static, :has(#nav.fixed), :has(#nav-sh.fixed) :has(#nav.sticky), :has(#nav-sh.sticky))').scrollToFixed();
					}
					var ul = $( "#nav-sh ul" ).first();
				  ul.on('scroll', function () {
				    if (ul.scrollLeft() > 0 ) {
				        ul.addClass('scrolled');
				    } else {
				      ul.removeClass('scrolled');
				    }
				  });
				},
				fancy: function () {
					a_tag.filter(':not([href="./"], [href^="#"], [rel="external"])').each(function () {
						this.ha = $(this).attr('href');
						this.isImage = /\.gif|jpg|png|png$/i.test(this.ha);
						this.isVideo = /youtu|vimeo|metacafe|dailymotion/i.test(this.ha) && !!$(this).addClass('fancy-video');
						if (!this.isImage && !this.isVideo) {
							return;
						}
						var coe = this;
						$(this).on('click', function () {
							var co = $(this),
								fcl = {},
								al = function () {};
							loadRes("//cdn.shopify.com/s/files/1/0312/7056/8069/t/4/assets/fancybox.js?v=10645630495575879731580211364", function () {
								if ($.fancybox !== undefined) {
									al = function () {
										var oo = {},
											ar = [],
											vo = {
												animationEffect: 'fade',
												onUpdate: function (instance, current) {
													var width,
														height,
														ratio = 16 / 9,
														video = current.$content;
													if (video) {
														video.hide();
														width = current.$slide.width();
														height = current.$slide.height() - 100;
														if (height * ratio > width) {
															height = width / ratio;
														} else {
															width = height * ratio;
														}
														video.css({
															width: width,
															height: height
														}).show();
													}
												}
											};
										if (co.attr('data-fancybox-group') !== undefined) {
											ar = [];
											$('[data-fancybox-group="' + co.attr('data-fancybox-group') + '"]').each(function () {
												ar.push({
													src: $(this).attr('href')
												});
											});
											oo = {
												arrows: true
											};
											if (coe.isVideo) {
												oo = $.extend(oo, vo);
											}
											$.fancybox.open(ar, oo, co.closest('.owl-item').length ? co.closest('.owl-item').index() : co.parent().index());
										} else {
											oo = {
												src: co.attr('href'),
												backFocus: false
											};
											if (coe.isVideo) {
												oo = $.extend(oo, vo);
											}
											$.fancybox.open(oo);
										}
									};
									if (!$('#fancycss').length) {
										fcl = $('<link>', {
											'id': 'fancycss',
											'rel': 'stylesheet',
											'href': "//cdn.shopify.com/s/files/1/0312/7056/8069/t/4/assets/fancybox.css?v=40973739740896057341580211363",
											'media': 'screen'
										});
										fcl.appendTo('head');
										fcl.on('load', al);
										return true;
									}
									al();
								}
							}, 'fancy-loaded');
							return false;
						});
					});
				},
				responsive: function () {
					var desktop_hide = $(document.getElementsByClassName('desktop-hide')),
						desktop_only = $(document.getElementsByClassName('desktop-only')),
						tablet_hide = $(document.getElementsByClassName('tablet-hide')),
						tablet_only = $(document.getElementsByClassName('tablet-only')),
						mobile_hide = $(document.getElementsByClassName('mobile-hide')),
						mobile_only = $(document.getElementsByClassName('mobile-only'));

					enquire.register('screen and (min-width: 1001px)', function () {
						if (desktop_only.length || tablet_hide.length || mobile_hide.length) {
							desktop_only.add(tablet_hide).add(mobile_hide).ariaRemove();
						}
						if (desktop_hide.length || tablet_only.length || mobile_only.length) {
							desktop_hide.add(tablet_only).add(mobile_only).ariaAdd();
						}
					}).register('screen and (min-width: 761px) and (max-width: 1000px)', function () {
						if (desktop_hide.length || tablet_only.length || mobile_hide.length) {
							desktop_hide.add(tablet_only).add(mobile_hide).ariaRemove();
						}
						if (desktop_only.length || tablet_hide.length || mobile_only.length) {
							desktop_only.add(tablet_hide).add(mobile_only).ariaAdd();
						}
					}).register('screen and (max-width: 760px)', function () {
						if (desktop_hide.length || tablet_hide.length || mobile_only.length) {
							desktop_hide.add(tablet_hide).add(mobile_only).ariaRemove();
						}
						if (desktop_only.length || tablet_only.length || mobile_hide.length) {
							desktop_only.add(tablet_only).add(mobile_hide).ariaAdd();
						}
						if (skip_id.length) {
							skip_id.find('a[href="#nav"], a[href="#mobile"]').attr('href', '#mobile');
						}
						// if (html_tag.is('.new:not(.no-usp)')) {
						// 	if (top_id.filter(':not(.static)').children('p:not(#logo)').length) {
						// 		top_id.trigger('detach.ScrollToFixed').scrollToFixed({
						// 			marginTop: -45 - 47
						// 		});
						// 	}
						// }
						// if (html_tag.is('.new.no-usp')) {
						if (html_tag.is('.new')) {
							if (top_id.filter(':not(.static)').children('p:not(#logo)').length) {
								top_id.trigger('detach.ScrollToFixed').scrollToFixed({
									marginTop: -45 - 47
								});
							}
						}
						// if (toggle_filters.length) {
						// 	toggle_filters.closest('.link-btn').trigger('detach.ScrollToFixed').scrollToFixed({
						// 		marginTop: 10 /*61*/
						// 	});
						// }
					}).register('screen and (min-width: 761px)', function () {
						if (toggle_filters.length) {
							toggle_filters.closest('.link-btn').trigger('detach.ScrollToFixed').scrollToFixed({
								marginTop: 10 /*61*/
							});
						}
						if (skip_id.length) {
							skip_id.find('a[href="#nav"], a[href="#mobile"]').attr('href', '#nav');
						}
						// if (!top_id.hasClass('no-sticky-header')) {
							// if (html_tag.is('.new:not(.no-usp)')) {
							// if (html_tag.is('.new:not(.no-usp)')) {
							// 	if (top_id.children('p:not(#logo)').length) {
							// 		top_id.trigger('detach.ScrollToFixed').scrollToFixed({
							// 			marginTop: -55 - 47
							// 		});
							// 	}
							// }
						// }
						if (!top_id.hasClass('no-sticky-header')) {
							// if (html_tag.is('.new.no-usp') || html_tag.is('.new.no-usp2')) {
								if (html_tag.is('.new')) {
								if (top_id.children('p:not(#logo)').length) {
									top_id.trigger('detach.ScrollToFixed').scrollToFixed({
										marginTop: -55
									});
								}
							}
						}
						if (toggle_filters.length) {
							toggle_filters.closest('.link-btn').trigger('detach.ScrollToFixed');
						}
					});
				},
				scrolling: function () {
					$(window).on('load scroll touchmove', function () {
						if ($(window).scrollTop() <= 0 ) {
							html_tag.removeClass('not-top');
						} else if ($(window).scrollTop() != 55) {
							html_tag.addClass('not-top');
						}
					});
					var lastScrollTop = 0;
					$(window).on('scroll mousewheel DOMMouseScroll touchmove', function () {
						var st = $(this).scrollTop();
						if (st > lastScrollTop) {
							html_tag.addClass('scrolled-down').removeClass('scrolled-up');
						} else {
							html_tag.removeClass('scrolled-down').addClass('scrolled-up');
						}
						lastScrollTop = st;
					});
					html_tag.on('DOMMouseScroll', function (e) {
						if (e.originalEvent.detail > 0) {
							html_tag.addClass('scrolled-down').removeClass('scrolled-up');
						} else {
							html_tag.addClass('scrolled-up').removeClass('scrolled-down');
						}
					});
					html_tag.on('mousewheel', function (e) {
						if (e.originalEvent.wheelDelta < 0) {
							html_tag.addClass('scrolled-down').removeClass('scrolled-up');
						} else {
							html_tag.addClass('scrolled-up').removeClass('scrolled-down');
						}
					});
				},
				waypoints: function () {
					body_tag.on('product-info-sticky', function (event) {
						if (module_product.length) {
							module_product.each(function () {
								var self = $(this);
								if ($(this).is(':not(:last-child)')) {
									$(this).find('.blank').remove();
									$(this).append('<div class="blank"></div>');
								}
								$(this).waypoint(function (direction) {
									if (direction === 'down') {
										html_tag.addClass('product-preview');
									}
								}, {
									offset: -self.outerHeight()
								});
								$(this).waypoint(function (direction) {
									if (direction === 'up') {
										html_tag.removeClass('product-preview');
									}
								}, {
									offset: -self.outerHeight()
								});
								$(this).children('div:not(.product-content):not(.blank)').each(function () {
									$(this).scrollToFixed({
										marginTop: function() {
											var top_sh = $('#top-sh'),
													nav_sh = $('#nav-sh'),
													stickyHeaderHeight = 24;
											if (!top_sh.hasClass('static') && !nav_id.hasClass('sticky') ) {
												stickyHeaderHeight = stickyHeaderHeight + top_sh.outerHeight();
											}
											if (nav_id.hasClass('sticky')) {
												stickyHeaderHeight = stickyHeaderHeight + nav_id.outerHeight();
											}
											return stickyHeaderHeight;
										},
										limit: function () {
											var limit = $('.blank').offset().top - $(this).outerHeight();
											return limit;
										},
										spacerClass: 'spacer'
									});
								});
							});
						}
					});
					body_tag.trigger('product-info-sticky');
					$(window).load(function() {
					      $(window).resize();
								$(window).scroll();
					});
				},
				miscellaneous: function () {
					if (window.location.href.indexOf("challenge") > -1) {
			      html_tag.animate({ scrollTop: 0 }, "slow");
			    }
					if (footer_id.find('.lang').length) {
						footer_id.find('.lang p a').on('click', function () {
							$(this).parents('.lang').toggleClass('toggle');
							return false;
						});
					}
					footer_id.find('nav :header').append('<a class="header-toggle" href="./"></a>').children('a.header-toggle').on('click', function () {
						$(this).parent().toggleClass('toggle');
						return false;
					});
					if (list_collection.length) {
						list_view.find('a:has(i)').on('click', function () {
							$(this).closest('.list-view').find('.active').removeClass('active');
							$(this).parent().addClass('active');
							list_collection.attr('data-layout', $(this).find('i').attr('class'));
							return false;
						});
					}
					if (form_sort.length) {
						form_sort.filter('.sticky').scrollToFixed({
							marginTop: 25,
							spacerClass: 'form-sort-spacer'
						});
					}
					if (toggle_filters.length) {
						toggle_filters.on('click', function () {
							html_tag.toggleClass('filter-active');
							return false;
						});
					}
					if (list_select.length) {
						list_select.each(function () {
							$(this).find('li > div').each(function () {
								$(this).find('input').on('change', function () {
									$(this).closest('div').each(function () {
										if ($(this).find('input:checked').length) {
											$(this).parent().addClass('is-checked');
										} else {
											$(this).parent().removeClass('is-checked');
										}
									});
								});
							}).siblings('a').each(function () {
								var t = $(this).text();
								$(this).empty().wrapInner('<span>' + t.substr(4) + '</span>').prepend(t.substring(0, 4));
							}).on('click', function () {
								if ($(this).parent().is('.toggle')) {
									$(this).parent().removeClass('toggle');
								} else {
									$(this).closest('.list-select').children('.toggle').removeClass('toggle');
									$(this).parent().addClass('toggle');
								}
								return false;
							});
							$(this).find('li.more > a').on('click', function () {
								$(this).find('span').toggleClass('hidden').closest('.list-select').toggleClass('toggle');
								return false;
							});
							$(this).find('a.remove').on('click', function () {
								$(this).closest('li').removeClass('is-checked').find('input:checked').attr('checked', false).removeAttr('checked');
								return false;
							});
						});
					}
					if (module_product_sticky.length) {
						module_product_sticky.append('<a class="close" href="./"></a>').children('.close').on('click', function () {
							html_tag.removeClass('confirm-cart');
							return false;
						});
					}
					if (form_product.length) {
						form_product.on('submit', function () {
							html_tag.addClass('confirm-cart').delay(5000).queue(function () {
								$(this).removeClass('confirm-cart').dequeue();
							});
							return false;
						});
					}
					if (toggle_quickshop.length) {
						toggle_quickshop.filter('input').each(function () {
							if ($(this).is(':checked')) {
								html_tag.addClass('quickshop-active');
								root_id.css('padding-bottom', module_quickshop.find('header').outerHeight());
							}
						}).on('change', function () {
							if ($(this).is(':checked')) {
								html_tag.addClass('quickshop-active');
								root_id.css('padding-bottom', module_quickshop.find('header').outerHeight());
							} else {
								html_tag.removeClass('quickshop-active');
								root_id.css('padding-bottom', 0);
							}
							return false;
						});
					}
					if (module_quickshop.length) {
						module_quickshop.find('header a:has(i[class*="chevron"])').on('click', function () {
							if ($(this).closest('.module-quickshop').is('.toggle')) {
								$(this).closest('.module-quickshop').removeClass('toggle');
								root_id.css('padding-bottom', module_quickshop.find('header').outerHeight());
							} else {
								$(this).closest('.module-quickshop').addClass('toggle');
								root_id.css('padding-bottom', module_quickshop.find('header').outerHeight() + module_quickshop.outerHeight());
							}
							return false;
						});
					}
					if (module_sections.length) {
						module_sections.children().children('header:first-child').find(':header').append('<a class="header-toggle" href="./"></a>').children('.header-toggle').on('click', function () {
							$(this).closest('header').toggleClass('toggle');
							return false;
						});
					}
					if (mobile_tab.length) {
						body_tag.on('mobile-tab', function (event) {
							var mobile_tab = $(document.getElementsByClassName('mobile-tab'));
							mobile_tab.children(':header:first-child').add(mobile_tab.children('header').children(':header:first-child')).on('click').on('click', function () {
								if ($(this).closest('.mobile-tab').hasClass('section-product-recommendations')) {
									body_tag.trigger('lazyload-again', [$(this).closest('.mobile-tab')]);
								}
								$(this).closest('.mobile-tab').toggleClass('toggle');
								return false;
							});
							mobile_tab.filter('.toggle-this').toggleClass('toggle');
						});
						body_tag.trigger('mobile-tab');
					}
					if (advanced_filters.length) {
						var filters = advanced_filters,
				       el,
				       elGroup,
				       elHandle,
				       activeTagInGroup;
						filters.each(function() {
							if (! $(this).closest(".list_select").length) {
								var anchor = $(this).find('a').first();
				        var text = anchor.text();
				        anchor.text('');
				        var label = $(this).find('label').first();
								// commented out the js for filters count
				        // var count = label.find('span').first().html();
				        $(this).children().wrapAll(anchor);
								// commented out the js for filters count
				        // label.html(text + " " + count);
								label.html(text);
							}
						});
						filters.on('click', function(e) {
			        el = $(this);
			        elGroup = el.data('group');
			        elHandle = el.data('handle');
			        activeTagInGroup = $('.active-filter[data-group="'+ elGroup +'"]');
			        // If the tag clicked is not already active and its group contains an active tag, we will swap tag within the group.
			        if ( !el.hasClass('active-filter')  && activeTagInGroup.size() ) {
			          e.preventDefault();
			          location.href = location.href
			            // swap tag
			            .replace(activeTagInGroup.data('handle'), elHandle)
			            // go back to page 1
			            .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, '');
			        }
			      });
					}
					body_tag.on('blog-tags', function (event) {
						blog_tags = $(document.getElementsByClassName('blog-tags'));
						if (blog_tags.length) {
							blog_tags.find('li:not(:first)').each(function() {
								var anchor = $(this).find('a').first();
					      var text = anchor.text();
					      var count = $(this).find('span').first();
								anchor.append(" <span>" + count.html() + "</span>");
								count.remove();
								$(this).show();
							});
						}
					});
					body_tag.trigger('blog-tags');
					if (quantity_select.length) {
						quantity_select.on("change paste keyup",function(){
							// clicks on the plus/min buttons are being handled in script.js
						    if(parseInt(jQuery(this).val()) > 0) {
						      $.ajax({
						        url: '/cart/change.js',
						        method: 'post',
										dataType: 'json',
						        data: {
						          quantity: parseInt(jQuery(this).val()),
						          line: jQuery(this).attr("data-line")
						        },
						        success: function() {
			              	window.location.reload();
						        },
						        error: function(XMLHttpRequest, textStatus){
											var data = eval('(' + XMLHttpRequest.responseText + ')');
											console.log(data);
						        }
						      });
								}
					  });
					}
				},
        productselect: function () {
        	// product page
          if (product_select_id.length) {
          	var productPrice = $('.module-product .price .current'),
            	productOldPrice = $('.module-product .price .old'),
              productSku = $('.module-product .list-plain .sku'),
              productBarcode = $('.module-product .list-plain .barcode'),
              discount = $('.module-product .price .label'),
							imageSaleTag = $('.module-product .image_sale_tag'),
							imageDiscountTag = $('.module-product .image_discount_tag'),
							stockAvailable = $('.module-product .stock .available'),
							stockUnavailable = $('.module-product .stock .unavailable'),
							stockAmount = $('.module-product .stock .amount'),
							addToCartButton = $('.module-product .add-to-cart-button'),
							unavailableCartButton = $('.module-product .unavailable-cart-button'),
							instantBuyButton = $('.module-product .instant_buy_button');

            product_select_id.on('change',function(){
            	var selectedOption = $(this).find(':selected'),
								price = selectedOption.data('price'),
              	oldPrice = selectedOption.data('old-price'),
								sku = selectedOption.data('sku'),
								barcode = selectedOption.data('barcode'),
								available = selectedOption.data('available'),
								stockamount = selectedOption.data('inventory-amount'),
								imgIndex = selectedOption.data('image-index') - 1;

							$('.module-product .list-slider .owl-carousel').trigger("to.owl.carousel", [imgIndex, 500]);
							$('.module-product .list-product .owl-carousel').trigger("to.owl.carousel", [imgIndex, 500]);
              productPrice.text(price);
							stockAmount.text("("+stockamount+")");

							if (sku) {
              	productSku.html("<span class='strong'>SKU: </span>"+sku);
							}
							if (barcode) {
              	productBarcode.html("<span class='strong'>Barcode: </span>"+barcode);
							}
							if (!sku && !barcode) {
								$('.module-product .list-plain').hide();
							} else {
								$('.module-product .list-plain').show();
							}
              if (oldPrice){
              	productOldPrice.text(oldPrice);
                discount.html("-"+selectedOption.data('discount')+"%");
								imageDiscountTag.html("-"+selectedOption.data('discount')+"%");
								productOldPrice.show();
                discount.show();
								imageSaleTag.show();
								imageDiscountTag.show();
              } else {
              	productOldPrice.text(" ");
                discount.hide();
								imageSaleTag.hide();
								imageDiscountTag.hide();
              }
							if (available) {
								stockAvailable.show();
								stockUnavailable.hide();
								addToCartButton.show();
								unavailableCartButton.hide();
								instantBuyButton.show();
							} else {
								stockAvailable.hide();
								stockUnavailable.show();
								addToCartButton.hide();
								unavailableCartButton.show();
								instantBuyButton.hide();
							}

            });
          }
					if (variant_select_snippet.length) {
						// product-item
						variant_select_snippet.each( function () {
							var product_item = $(this).closest('li'),
							 	productPrice = product_item.find($('.price .current')),
	            	productOldPrice = product_item.find($('.price .old')),
								imageSaleTag = product_item.find($('.image_sale_tag')),
								imageDiscountTag = product_item.find($('.image_discount_tag'));

							$(this).on('change', function () {
								var selectedOption = $(this).find(':selected'),
									price = selectedOption.data('price'),
	              	oldPrice = selectedOption.data('old-price'),
									discount = selectedOption.data('discount');

								productPrice.text(price);
								if (oldPrice){
	              	productOldPrice.text(oldPrice);
									imageDiscountTag.html("-"+discount+"%");
									productOldPrice.show();
									imageSaleTag.show();
									imageDiscountTag.show();
	              } else {
	              	productOldPrice.text(" ");
									imageSaleTag.hide();
									imageDiscountTag.hide();
	              }
							})
						})
					}
          $('[id^="ProductSelect-"]').on('change',function(){
          	var optionsString = '';
            $('[id^="ProductSelect-"]:checked, [id^="ProductSelect-"]:selected').each(function(){
            	if (optionsString !== ''){
              	optionsString = optionsString + ' / ';
              }
              optionsString = optionsString + $(this).val();
            });
						$('#AddToCartForm [name="id"] option').removeAttr('selected');
            $('#AddToCartForm [name="id"] option').filter(function(){
            	return this.textContent.startsWith(optionsString)
            }).attr('selected','selected');
            $('#productSelect').trigger('change');
            $('.module-product-bar .AddToCartForm [name="id"]').val($('#AddToCartForm [name="id"] option:selected').val()).change()
          });
        },
				notifications: function () {
					// also in assets/ajax-cart.js.liquid
					if ($('.list-notifications').length) {
						var stickyHeaderHeight = 0;
						if (!top_sh.hasClass('static') && !nav_id.hasClass('sticky') ) {
							stickyHeaderHeight = stickyHeaderHeight + top_sh.outerHeight();
						}
						if (nav_id.hasClass('sticky')) {
							stickyHeaderHeight = stickyHeaderHeight + nav_id.outerHeight();
						}
						$('.list-notifications').scrollToFixed({
							marginTop: stickyHeaderHeight
						});
						// $('.list-notifications').scrollToFixed()
						// .find('a.close').on('click', function () {
						// 	$(this).closest('li').slideUp();
						// 	return false;
            //   });
						$('.list-notifications').delay(6000).queue(function(){
							$(this).slideUp().dequeue().delay(500).queue(function(){
								$(this).remove().dequeue();
							});
						});
					}
				}
			}
		};

	Default.async.links();
	Default.async.forms();
	Default.async.productselect();
	Default.async.miscellaneous();
	Default.async.fancy();
	Default.async.waypoints();
	Default.async.scrolling();
	Default.async.responsive();
	Default.async.notifications();
	Default.async.nav();
	$(window).resize();
	$(window).scroll();
});

/*!*/
